export default {
  meta: {
    title: '规划统计',
    parentPath: ['/recommend/networkplan'],
    breadcrumbs: {
      path: ['/recommend/networkplan'],
      name: ['规划管理'],
    },
  },
};

// networkbranchplanstatistics
